import React from 'react';
import SuperUserModal from '@components/organisms/modals/superUserModal';
import { useNavigate } from 'react-router-dom';

const SuperUserPage = () => {
  const navigate = useNavigate();

  if (localStorage.getItem('isSuperUser') !== 'true') {
    navigate('/');
    return null;
  }
  return <SuperUserModal />;
};

export default SuperUserPage;
